enum PagePaths {
  Bundle = 'bundle',
  Energy = 'energy',
  EnergyDetails = 'energy-details',
  Broadband = 'broadband',
  Mobile = 'mobile',
  SaveForLater = 'save-for-later',
  Order = 'order',
  Confirm = 'confirm',
  ThankYou = 'thank-you',
  Deposit = 'deposit',
  BHC = 'bhc',
  IP = 'ip',
  Insurance = 'insurance',
  Cashback = 'cashback',
  Partner = 'partner',
  Presentation = 'presentation',
  Remote = 'remote',
  Start = 'start',
  Join = 'join',
  RemoteSetup = 'setup',
  RemoteLobby = 'lobby',
}

const getBundlePagePath = (path: string) => `/${PagePaths.Bundle}/${path}`;
const getOrderPagePath = (path: string) => `/${PagePaths.Order}/${path}`;
const getInsurancePagePath = (path: string) =>
  `${getBundlePagePath(PagePaths.Insurance)}/${path}`;

const bundlePaths = {
  bundle: `/${PagePaths.Bundle}`,
  energy: getBundlePagePath(PagePaths.Energy),
  energyDetails: `${getBundlePagePath(PagePaths.Energy)}/${PagePaths.EnergyDetails}`,
  broadband: getBundlePagePath(PagePaths.Broadband),
  mobile: getBundlePagePath(PagePaths.Mobile),
  saveForLater: getBundlePagePath(PagePaths.SaveForLater),
  insurance: getBundlePagePath(PagePaths.Insurance),
  bhc: getInsurancePagePath(PagePaths.BHC),
  ip: getInsurancePagePath(PagePaths.IP),
  cashback: getBundlePagePath(PagePaths.Cashback),
} as const;

const orderPaths = {
  order: `/${PagePaths.Order}`,
  confirm: getOrderPagePath(PagePaths.Confirm),
  thankYou: getOrderPagePath(PagePaths.ThankYou),
  deposit: getOrderPagePath(PagePaths.Deposit),
} as const;

const sessionPaths = {
  partner: `/${PagePaths.Partner}`,
  presentation: `/${PagePaths.Presentation}`,
  remoteStart: `/${PagePaths.Remote}/${PagePaths.Start}`,
  remoteJoin: `/${PagePaths.Remote}/${PagePaths.Join}`,
  remoteSetup: `/${PagePaths.Remote}/${PagePaths.RemoteSetup}`,
  remoteLobby: `/${PagePaths.Remote}/${PagePaths.RemoteLobby}`,
} as const;

const paths: { [key: string]: string } = {
  root: '/',
  address: '/address',
  ...orderPaths,
  ...bundlePaths,
  ...sessionPaths,
} as const;

export { paths, PagePaths };
